<!--  -->
<template>
  <div>
    <el-form :model="formInline" class="demo-form-inline">
      <el-form-item label="选择企业">
        <el-select v-model="formInline.corpId" placeholder="请选择企业">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.corpName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="群聊名称">
        <el-input v-model="formInline.name" style="width:200px" placeholder="请输入群聊名称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="suanee">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { groupchatcreate, enterprisefiltering } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      formInline: {
        corpId: '',
        name: ''
      },
      options: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      this.panglist()
    },
    // 获取企业筛选接口
    async panglist() {
      const data = await enterprisefiltering()
      this.options = data.data
      console.log('data', data)
    },
    async suanee() {
      // eslint-disable-next-line eqeqeq
      if (this.formInline.corpId == '') {
        this.$message.error('请选择企业')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.formInline.name == '') {
        this.$message.error('请输入群聊名称')
        return
      }
      const data = await groupchatcreate(this.formInline)
      this.$message({
        type: 'success',
        message: '群聊创建成功'
      })
      this.$emit('createupdata')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
